module.exports = __webpack_public_path__ + "img/ipad.1ef4eb9b.png";